export default __webpack_public_path__ + "partner_748f303.png";